import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { useFocusTrap } from '@websolutespa/bom-mixer-hooks';
import { motion } from 'framer-motion';
import { useRef } from 'react';
import { useLlm } from '../../../useLlm/useLlm.js';
import { useLlmView } from '../../../useLlm/useLlmView.js';

const Main = () => {
  var _a;
  const {
    Canvas,
    Header,
    Intro,
    Prompt,
    Scroller,
    ScrollProposition,
    Thread
  } = useLlm(state => state.components);
  const app = useLlm(state => state.app);
  const theme = useLlm(state => state.theme);
  const messages = useLlm(state => state.messages);
  const introed = useLlmView(state => state.introed);
  const visible = useLlmView(state => state.visible);
  const embedded = useLlmView(state => state.embedded);
  const reveal = {
    hidden: {
      opacity: 0,
      scale: .98
    },
    show: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: .3
      }
    },
    exit: {
      opacity: 0,
      transition: {
        duration: .3,
        delay: .3
      }
    }
  };
  const intro = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        delay: .6,
        duration: .5
      }
    }
  };
  const slideIn = direction => ({
    hidden: {
      y: `${100 * direction}%`
    },
    show: {
      y: 0,
      transition: {
        type: 'tween',
        delay: (app === null || app === void 0 ? void 0 : app.contents.customIntro) ? 0 : 1.2,
        duration: .6
      }
    },
    exit: {
      y: `${100 * direction}%`,
      transition: {
        type: 'tween',
        duration: .3
      }
    }
  });
  const shouldShowPrompt = !(app === null || app === void 0 ? void 0 : app.contents.customIntro) || introed;
  const trapRef = useRef(null);
  // !!! do not remove
  useFocusTrap(trapRef, {
    disabled: embedded
  });
  return jsxs(motion.div, {
    className: "llm__main",
    variants: reveal,
    initial: "hidden",
    animate: "show",
    exit: "exit",
    "data-main": true,
    "data-lenis-prevent": true,
    ref: trapRef,
    children: [visible && jsx(Canvas, {}), !embedded && jsx(motion.div, {
      className: "llm__top",
      variants: slideIn(-1),
      initial: "hidden",
      animate: "show",
      exit: "exit",
      children: jsx(Header, {})
    }), jsx(Scroller, {
      children: jsxs(motion.div, {
        variants: intro,
        initial: "hidden",
        animate: "show",
        className: "llm__content",
        children: [jsx(Intro, {}), messages && messages.length > 0 && jsx(Thread, {})]
      })
    }), shouldShowPrompt && jsxs(Fragment, {
      children: [app && !((_a = theme.canvas) === null || _a === void 0 ? void 0 : _a.enabled) && jsx("div", {
        className: "llm__underlay",
        "aria-hidden": true
      }), jsxs(motion.main, {
        className: "llm__bottom",
        variants: slideIn(1),
        initial: "hidden",
        animate: "show",
        exit: "exit",
        children: [jsx(ScrollProposition, {}), jsx(Prompt, {})]
      })]
    })]
  }, "main-container");
};

export { Main };
//# sourceMappingURL=main.js.map
